import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
const ValueDisplayPair = (value, displayName) => z.object({
    value: z.literal(value),
    displayName: z.literal(displayName),
});
export const ApexAccountTypes = z.tuple([
    z.literal("Apex"),
    z
        .union([
        ValueDisplayPair("Individual", "Individual"),
        ValueDisplayPair("IRA", "IRA"),
        ValueDisplayPair("Roth IRA", "Roth IRA"),
        ValueDisplayPair("Sep IRA", "Sep IRA"),
        ValueDisplayPair("Trust", "Trust"),
        ValueDisplayPair("Joint WROS", "Joint WROS"),
        ValueDisplayPair("Joint TIC", "Joint TIC"),
        ValueDisplayPair("Joint CP", "Joint CP"),
        ValueDisplayPair("Other", "Other"),
        ValueDisplayPair("Asset Lending", "Asset Lending"),
        ValueDisplayPair("Joint TE", "Joint TE"),
        ValueDisplayPair("Rollover IRA", "Rollover IRA"),
        ValueDisplayPair("Inherited IRA", "Inherited IRA"),
        ValueDisplayPair("Inherited Roth IRA", "Inherited Roth IRA"),
    ])
        .array(),
]);
export const PershingAccountTypes = z.tuple([
    z.literal("Pershing"),
    z
        .union([
        ValueDisplayPair("Individual", "Individual"),
        ValueDisplayPair("IRA", "IRA"),
        ValueDisplayPair("Roth IRA", "Roth IRA"),
        ValueDisplayPair("Sep IRA", "Sep IRA"),
        ValueDisplayPair("Trust", "Trust"),
        ValueDisplayPair("Joint WROS", "Joint WROS"),
        ValueDisplayPair("Joint TIC", "Joint TIC"),
        ValueDisplayPair("Joint CP", "Joint CP"),
        ValueDisplayPair("Other", "Other"),
        ValueDisplayPair("Asset Lending", "Asset Lending"),
        ValueDisplayPair("Joint TE", "Joint TE"),
        ValueDisplayPair("Rollover IRA", "Rollover IRA"),
        ValueDisplayPair("Inherited IRA", "Inherited IRA"),
        ValueDisplayPair("Inherited Roth IRA", "Inherited Roth IRA"),
    ])
        .array(),
]);
export const SchwabAccountTypes = z.tuple([
    z.literal("Schwab"),
    z
        .union([
        ValueDisplayPair("Individual", "Individual"),
        ValueDisplayPair("JTWROS", "JTWROS / Joint Tenant"),
        ValueDisplayPair("TIC", "Tenants in Common (TIC)"),
        ValueDisplayPair("CommunityProperty", "Community Property"),
        ValueDisplayPair("CustodialUtmaUgma", "Custodial (UTMA / UGMA)"),
        ValueDisplayPair("ContributoryTraditionalIRA", "Contributory / Traditional IRA"),
        ValueDisplayPair("RolloverIRA", "Rollover IRA"),
        ValueDisplayPair("InheritedIRA", "Inherited IRA"),
        ValueDisplayPair("TrustRevocable", "Trust - Revocable"),
        ValueDisplayPair("TrustIrrevocable", "Trust - Irrevocable"),
        ValueDisplayPair("SchwabCharitableDonorAdvisedFundAccount", "Schwab Charitable / Donor-Advised Fund Account"),
    ])
        .array(),
]);
export const FidelityAccountTypes = z.tuple([
    z.literal("Fidelity"),
    z
        .union([
        ValueDisplayPair("ConservatorGuardian", "Conservator / Guardian"),
        ValueDisplayPair("Corporation", "Corporation"),
        ValueDisplayPair("Estate", "Estate"),
        ValueDisplayPair("Individual", "Individual"),
        ValueDisplayPair("JTWROS", "JTWROS"),
        ValueDisplayPair("TIE", "Tenants in Entirety(TIE)"),
        ValueDisplayPair("TIC", "Tenants in Common (TIC)"),
        ValueDisplayPair("CommunityProperty", "Community Property"),
        ValueDisplayPair("LLC", "LLC"),
        ValueDisplayPair("Partnership", "Partnership"),
        ValueDisplayPair("RolloverIRA", "Rollover IRA"),
        ValueDisplayPair("RothIRA", "Roth IRA"),
        ValueDisplayPair("SepIRA", "SEP IRA"),
        ValueDisplayPair("SoleProprietorship", "Sole Proprietorship"),
        ValueDisplayPair("TraditionalIRA", "Traditional IRA"),
        ValueDisplayPair("TrustRevocable", "Trust - Revocable"),
        ValueDisplayPair("TrustIrrevocable", "Trust - Irrevocable"),
        ValueDisplayPair("UtmaUgma", "UTMA / UGMA"),
        ValueDisplayPair("UnincorporatedAssociation", "Unincorporated Association"),
    ])
        .array(),
]);
export const CustodianAccountTypes = z.union([
    ApexAccountTypes,
    PershingAccountTypes,
    SchwabAccountTypes,
    FidelityAccountTypes,
]);
export const AccountTypesResponse = z.object({
    values: CustodianAccountTypes.array(),
});
export const planAccountTypesUrl = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/account/v2/plans/account-types"
    : "https://middleware.uat.farther.com/account/v2/plans/account-types";
export default async function getPlanAccountTypesV2(config) {
    const { data } = await axios.get(planAccountTypesUrl(), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = AccountTypesResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data.values;
    }
    else {
        const errorMessage = `[${getPlanAccountTypesV2.name}] Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getPlanAccountTypesV2.js.map